import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../config";
import profile_icon from '../assets/icons/bold/Profile.svg';
import { useTheme } from "../context/ThemeContext";

const themeOptions = ["#ffffff", "#1a1a1a", "#E68F5A", "#D0E8FF"];

function SettingsUI({ onOpen, userData }) {
    const navigate = useNavigate();
    const { themeColor, changeTheme } = useTheme();
    const [themeDropdownOpen, setThemeDropdownOpen] = useState(false);

    const handleLogout = async () => {
        try {
            await auth.signOut();
            localStorage.clear();
            sessionStorage.clear();
            navigate("/");
        } catch (error) {
            console.error("Шығу кезінде қате:", error);
        }
    };

    return (
        <div className="m-6 text-[var(--text-color)]">
            <div className="flex items-center gap-4 pb-6 border-b border-[var(--accent-color)]">
                <img
                    src={userData?.photoURL || profile_icon}
                    alt="Пайдаланушы"
                    className="w-12 h-12 rounded-full"
                />
                <div>
                    <h2 className="font-semibold text-lg">{userData?.displayName || "Аты жоқ"}</h2>
                    <button onClick={() => onOpen(true)} className="text-[var(--accent-color)] text-sm">
                        Профильді қарау
                    </button>
                </div>
            </div>

            <ul className="mt-4 space-y-4">
                <li onClick={() => navigate("/faq")} className="cursor-pointer hover:text-[var(--accent-color)]">Жиі қойылатын сұрақтар</li>
                <li onClick={() => navigate("/privacy-policy")} className="cursor-pointer hover:text-[var(--accent-color)]">Құпиялылық саясаты</li>
                <li onClick={() => navigate("/terms-of-use")} className="cursor-pointer hover:text-[var(--accent-color)]">Қолдану шарттары</li>
                <li onClick={() => navigate("/buy-book-problem")} className="cursor-pointer hover:text-[var(--accent-color)]">Кітап сатып алуда қиындықтар</li>
                {/* Add new link for Saved Audio */}
                <li onClick={() => navigate("/saved-audio")} className="cursor-pointer hover:text-[var(--accent-color)]">Сақталған аудиолар</li>
                <li className="cursor-pointer hover:text-[var(--accent-color)] relative">
                    <div onClick={() => setThemeDropdownOpen(!themeDropdownOpen)}>Тақырыпты таңдау</div>
                    {themeDropdownOpen && (
                        <div className="absolute z-10 mt-2 bg-white dark:bg-gray-800 border rounded p-3 shadow-xl grid grid-cols-4 gap-2">
                            {themeOptions.map((color) => (
                                <div
                                    key={color}
                                    onClick={() => changeTheme(color)}
                                    className="w-[30px] h-[20px] rounded cursor-pointer relative border"
                                    style={{ backgroundColor: color }}
                                >
                                    {themeColor === color && (
                                        <div className="absolute bottom-[-8px] left-1/2 transform -translate-x-1/2">
                                            <input type="checkbox" checked readOnly />
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </li>
            </ul>

            <button
                onClick={handleLogout}
                className="mt-6 w-full border border-red-500 text-red-500 py-2 rounded-lg hover:bg-red-100"
            >
                Шығу
            </button>
        </div>
    );
}

export default SettingsUI;